module.exports = __webpack_public_path__ + "img/accessory.d267c2a3.png";